function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M274-274l-100-55q-11-6-12.5-17.5T168-366l12-12q4-4 9.5-5.5t10.5-.5l88 12 156-156-272-148q-15-8-17.5-25t9.5-29l10-10q7-7 15.5-9t17.5 0l363 93 157-155q17-17 42.5-17t42.5 17q17 17 17 42.5T812-726L656-570l93 361q2 10-.5 19.5T739-173l-5 5q-14 14-32.5 11T674-177L528-444 372-288l12 86q1 7-1 13t-7 11l-5 5q-10 10-24 8.5T326-179l-52-95z"
  }));
};
const SvgAirplane = styled(BaseComponent).withConfig({
  displayName: "Airplane__SvgAirplane",
  componentId: "sc-1onfzjj-0"
})(["outline:none;"]);
SvgAirplane.isIcon = true;
export default SvgAirplane;